import { ListQuery } from '@onArte/shared/models/common';

export class PostsListQuery extends ListQuery {}
